<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12 header n126">
		<mat-icon class="mat-icon-rtl-mirror help">help</mat-icon>

		<h1>{{ locale.translations['help']['n126'] }}</h1>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<mat-nav-list>
			<a mat-list-item [href]="'/' + locale.getLocale() + '/help/place-ad'" class="n127">
				<mat-icon matListIcon class="mat-icon-rtl-mirror">add_circle_outline</mat-icon>

				<h2 matLine>{{ locale.translations['help']['placead']['n127'] }}</h2>
			</a>

			<a mat-list-item [href]="'/' + locale.getLocale() + '/vip'">
				<mat-icon matListIcon class="mat-icon-rtl-mirror">credit_card</mat-icon>

				<h2 matLine>{{ locale.translations['help']['pricing']['n228'] }}</h2>
			</a>

			<a mat-list-item [href]="'/' + locale.getLocale() + '/vip-plus'"  class="n201">
				<mat-icon matListIcon class="mat-icon-rtl-mirror">trending_up</mat-icon>

				<h2 matLine>{{ locale.translations['n723'] }}</h2>
			</a>

			<a mat-list-item [href]="'/' + locale.getLocale() + '/campaign'" >
				<mat-icon matListIcon class="mat-icon-rtl-mirror">store</mat-icon>

				<h2 matLine>{{ locale.translations['help']['campaign']['n254'] }}</h2>
			</a>

			<a mat-list-item [href]="'/' + locale.getLocale() + '/help/logup'" class="n128">
				<mat-icon matListIcon class="mat-icon-rtl-mirror">exit_to_app</mat-icon>

				<h2 matLine>{{ locale.translations['help']['logup']['n128'] }}</h2>
			</a>

			<a mat-list-item [href]="'/' + locale.getLocale() + '/help/language'" class="n129">
				<mat-icon matListIcon>language</mat-icon>

				<h2 matLine>{{ locale.translations['help']['language']['n129'] }}</h2>
			</a>
		</mat-nav-list>
	</div>
</div>
